import React from 'react';
import { SectionIcon } from './SectionIcon';

// `icon`: an Ant Design icon shown before the title
export const SectionHead = ({ id, title, sub, icon, as: Heading = 'h2', children }) => (
    <div className="sechead" style={{ alignItems: 'baseline' }}>
        <Heading id={id} className={Heading === 'h2' ? 'h2' : 'h3'}>
            {icon && <SectionIcon icon={icon} />}
            {title}
        </Heading>
        {sub && <span className="muted">{sub}</span>}
        {children}
    </div>
);
